module.exports = __webpack_public_path__ + "img/breaking-news.4c97d943.png";